/**
 * `phone` → **Settings** (spec M2 tier-2 §5.8, card P-123).
 *
 * The captured `Settings` submenu (`editors/phone/settings-menu.json`) has no *Customize* row;
 * `phoneSettingsSchema` carries one type-owned key, `show_flag` — the country flag the cell draws
 * in front of the digits, derived from `value.countryShortName`.
 *
 * Nothing here validates a number: monday uses libphonenumber and this product deliberately does
 * not (q331), so there is no "format as you type" setting to offer.
 */
import type { PhoneSettings } from '@elizmonday/shared';
import {
  HideSummaryField,
  SettingsCheckbox,
  SettingsForm,
  useSettingsDraft,
} from '../settings-kit';
import type { ColumnSettingsProps } from '../types';

export function PhoneSettingsDialog({ settings, onCommit, onCancel }: ColumnSettingsProps<PhoneSettings>) {
  const [draft, patch] = useSettingsDraft<PhoneSettings>(settings);
  return (
    <SettingsForm
      title="Phone column settings"
      testId="phone-settings"
      onSave={() => onCommit(draft)}
      onCancel={onCancel}
    >
      <SettingsCheckbox
        label="Show the country flag"
        testId="phone-show-flag"
        checked={draft.show_flag ?? false}
        onChange={(next) => patch({ show_flag: next })}
      />
      <HideSummaryField
        testId="phone-hide-footer"
        checked={draft.hide_footer ?? false}
        onChange={(next) => patch({ hide_footer: next })}
      />
    </SettingsForm>
  );
}
